import Vue from "vue";
import VueI18n from "vue-i18n";

// 导入模块化语言文件
import zhCN from "./modules/zh-CN/index.js";
import zhTW from "./modules/zh-TW/index.js";
import en from "./modules/en/index.js";

// Element UI的国际化
import elementEnLocale from "element-ui/lib/locale/lang/en.js";
import elementZhCNLocale from "element-ui/lib/locale/lang/zh-CN.js";
import elementZhTWLocale from "element-ui/lib/locale/lang/zh-TW.js";

Vue.use(VueI18n);

// 合并语言包
const messages = {
  "zh-CN": {
    ...zhCN,
    ...elementZhCNLocale,
  },
  "zh-TW": {
    ...zhTW,
    ...elementZhTWLocale,
  },
  en: {
    ...en,
    ...elementEnLocale,
  },
};

// 获取浏览器语言设置
function getLanguage() {
  // 优先读取新版首选语言键，其次兼容旧键
  const preferred = localStorage.getItem("preferred-language");
  if (preferred) return preferred;

  const legacy = localStorage.getItem("language");
  if (legacy) return legacy;

  // 如果没有选择语言
  const language = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return "zh-CN";
}

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: "zh-CN", // 设置备用语言
  messages,
  silentTranslationWarn: true, // 关闭警告
});

export default i18n;
